import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import React, {useRef, useState} from "react";
import {ProductQty} from "../types/ProductQty";
import {useGetOptionalProducts} from "../api/get-optional-products";
import {useEEToolContext} from "../contexts/eeToolContext";
import DataGrid, {Column, Editing, Format, Paging, Scrolling, Selection} from "devextreme-react/data-grid";
import {LoadPopupPanel} from "../../../../components";
import {EditOptionalProduct} from "../types/EditOptionalProduct";

export function OptionalItemsPopupControl(props: {
    visible: boolean,
    onPopupHidden: () => void,
    onProductsAdded: (newProducts: ProductQty[]) => void
}) {
    const context = useEEToolContext();
    const optionalProducts = useGetOptionalProducts(context.dealerId, context.prodQteGroups, context.customerZip, props.visible);
    const optionalProductsRef = useRef<DataGrid>(null);

    const getOKButtonOptions = {
        stylingMode: 'contained',
        text: 'OK',
        onClick: () => {
            const selectedRows = optionalProductsRef.current?.instance.getSelectedRowsData() as EditOptionalProduct[];
            if (selectedRows && selectedRows.length > 0) {
                var mappedItems = selectedRows.map(x => ({ProductID: x.productID, Quantity: x.quantity} as ProductQty));
                props.onProductsAdded(mappedItems);
            }
            props.onPopupHidden();
        }
    };

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => {
            props.onPopupHidden();
        }
    };

    if (!props.visible)
        return <></>;

    return (
        <>
            <Popup
                title='Add Optional Item(s)'
                visible={props.visible}
                hideOnOutsideClick={true}
                showCloseButton={true}
                onHidden={() => {
                    props.onPopupHidden()
                }}
            >
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getOKButtonOptions}
                />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <DataGrid
                    ref={optionalProductsRef}
                    className="product-search-results"
                    dataSource={optionalProducts.data}
                    allowColumnResizing={true}
                    wordWrapEnabled={true}
                    keyExpr={['productID']}
                    repaintChangesOnly={true}
                    onSelectionChanged={(e) => {
                        if (e.currentSelectedRowKeys.length > 0) {
                            e.currentSelectedRowKeys.forEach((value, index, array) => {
                                if (optionalProducts.data) {
                                    var o = optionalProducts.data.find(x => x.productID === value.productID);
                                    if (o) {
                                        o.quantity = 1;
                                        if (optionalProductsRef.current) {
                                            optionalProductsRef.current.instance.refresh();
                                        }
                                    }
                                }
                            });
                        }
                    }}
                >
                    <Paging enabled={false}></Paging>
                    <Scrolling rowRenderingMode='virtual'></Scrolling>
                    <Selection mode="multiple" allowSelectAll={false}/>
                    <Editing allowUpdating={true} mode={'cell'} refreshMode={'repaint'}></Editing>
                    <Column
                        dataField="sku"
                        caption="SKU"
                        dataType="string"
                        allowEditing={false}
                    />
                    <Column
                        dataField="description"
                        caption={'Description'}
                        dataType="string"
                        allowEditing={false}
                    />
                    <Column
                        dataField={'retailPrice'}
                        caption={'Price'}
                        dataType="number"
                        allowEditing={false}
                        width={120}
                    >
                        <Format type="currency" precision={2}></Format>
                    </Column>
                    <Column
                        dataField={'quantity'}
                        caption="Quantity"
                        width={100}
                        dataType={'number'}
                        editorOptions={{showSpinButtons: true, min: 1, format: "##0.###"}}
                        showEditorAlways={true}
                    />
                    <Column
                        dataField={'uom'}
                        caption={'UOM'}
                        dataType="string"
                        width={100}
                        allowEditing={false}
                    />
                </DataGrid>
                <LoadPopupPanel visible={optionalProducts.isLoading}></LoadPopupPanel>
            </Popup>
        </>
    );
}
